import { render, staticRenderFns } from "./TablaInscripcionesProgramaUniversidad.vue?vue&type=template&id=20c5b6fb"
import script from "./TablaInscripcionesProgramaUniversidad.vue?vue&type=script&lang=js"
export * from "./TablaInscripcionesProgramaUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports